export function validateEmail (email) {
  let validation = /\S+@\S+\.\S+/
  return validation.test(email)
}
